export default "__VITE_ASSET__DqqHPRbq__"